<section>    
    <div class="content bg">
        <div class="container-fluid" style="height: 70vh;">
            <div class="dashboard">
                <p>SITE OVERVIEW</p>                
            </div>
            <div class="container-fluid border_box">
                <div class="section">
                    <h6>Sites</h6>                    
                </div>
                <div class="section">
                    <h6>Monitors</h6>
               </div>
            </div>
            <div class="container-fluid border_box">
                <div class="section">
                    <h6>Sitedown Ticket Status</h6>
               </div>
               <div class="section">
                <div style="height:50%" class="border1px_white">
                    <h6>Total Sitedown Tickets</h6>
                </div>
                 <div style="height:50%" class="border1px_white">
                    <h6>Open Sitedown Tickets</h6>
                 </div>                
                </div>
            </div>
            <div class="container-fluid border_box">	     
                <div class="section">
                    <h6>Camera Count</h6>
                </div>
                <div class="section">
                    <h6>Ofline Camera Count</h6>
                </div>           
           </div>
        </div>
    </div>
</section>

